var __rspack_ns_object = JSON.parse('{"ARTIST_FESTIVALS":{"TITLE":"Festivals"},"ARTIST_SHOWS":{"TITLE":"Touring","SUPPORT_ACT":"Support Act"}}')